import { useCategoryPageQuery } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useCategoryPageQuery/useCategoryPageQuery";

export const useIsCategoryPageLoading = (): boolean => {
  const { isFetching, data } = useCategoryPageQuery();
  return isFetching || data === undefined; // data === undefined accounts for disabled query
};

export const useCategoryPageDataUpdatedAt = (): number => {
  const { dataUpdatedAt } = useCategoryPageQuery();
  return dataUpdatedAt;
};
